import { UserCommentAreaProps } from "types/userArea";
import { MODAL_CONTENT_TAB_INDEX, MODAL_COMMENT_TEXTAREA_MAX_LENGTH } from "utils/constants";
import { TextArea } from "components/common/TextArea.component";
import { FormField } from "components/common/FormField.component";

const TEXTAREA_ID = "workflow_user_comment_textarea";

export function UserCommentArea(props: UserCommentAreaProps) {
    return (
        <div className="w-100 pr-2">
            {props.message && (
                <>
                    <div className="mb-4 text-default">
                        {props.message}
                    </div>
                    <br />
                </>
            )}
            <FormField
                id={TEXTAREA_ID}
                label={props.inputMessage}
                info={{ label: props.moreInfo }}
            >
                <TextArea
                    id={TEXTAREA_ID}
                    maxLength={MODAL_COMMENT_TEXTAREA_MAX_LENGTH}
                    tabIndex={MODAL_CONTENT_TAB_INDEX}
                    ref={props.userInput}
                />
            </FormField>
        </div>

    );
}

export default UserCommentArea;
